/*
 * Dawn's SliderComponent is horizontal-only: initPages() derives its step from
 * offsetLeft and update() reads scrollLeft. At >=990px the PDP thumbnail rail is
 * flipped to a vertical column, so every item shares an offsetLeft, the step
 * collapses to 0 and scrollLeft is permanently 0 -- the up arrow stays disabled
 * (and CSS hides disabled arrows), so the rail cannot be scrolled by its buttons.
 *
 * This takes over the rail only while the vertical layout is active and defers
 * to Dawn's own logic at narrower widths.
 */
(function () {
  const DESKTOP = '(min-width: 990px)';
  const RAIL = '.product__media-wrapper media-gallery .thumbnail-slider';

  const isVertical = () => window.matchMedia(DESKTOP).matches;

  function parts(rail) {
    return {
      list: rail.querySelector('.thumbnail-list'),
      prev: rail.querySelector('button[name="previous"]'),
      next: rail.querySelector('button[name="next"]'),
    };
  }

  function stepFor(list) {
    const item = list.querySelector('.thumbnail-list__item');
    if (!item) return list.clientHeight;
    const gap = parseFloat(getComputedStyle(list).rowGap) || 0;
    return (item.getBoundingClientRect().height + gap) * 2;
  }

  // The rail rests a few px off zero (list padding plus scroll snapping), so an
  // exact 0 comparison would leave the up arrow showing while already at the top.
  const EDGE = 8;

  function syncVertical(rail) {
    const { list, prev, next } = parts(rail);
    if (!list || !prev || !next) return;
    const max = list.scrollHeight - list.clientHeight;
    if (max <= EDGE) {
      prev.disabled = true;
      next.disabled = true;
      return;
    }
    prev.disabled = list.scrollTop <= EDGE;
    next.disabled = list.scrollTop >= max - EDGE;
  }

  function bind(rail) {
    if (rail.dataset.verticalRail) return;
    rail.dataset.verticalRail = 'true';

    const { list } = parts(rail);
    if (!list) return;

    // Route Dawn's own hooks to the vertical implementation when it applies,
    // leaving the horizontal behaviour untouched below 990px.
    if (typeof rail.initPages === 'function') {
      const originalInit = rail.initPages.bind(rail);
      rail.initPages = function () {
        if (isVertical()) return syncVertical(rail);
        return originalInit();
      };
    }
    if (typeof rail.update === 'function') {
      const originalUpdate = rail.update.bind(rail);
      rail.update = function () {
        if (isVertical()) return syncVertical(rail);
        return originalUpdate();
      };
    }

    list.addEventListener('scroll', () => isVertical() && syncVertical(rail), { passive: true });
    new ResizeObserver(() => isVertical() && syncVertical(rail)).observe(list);
    if (isVertical()) syncVertical(rail);
  }

  // Capture phase so this runs before the click listener Dawn bound to the button.
  document.addEventListener(
    'click',
    function (event) {
      if (!isVertical()) return;
      const button = event.target.closest('.thumbnail-slider .slider-button');
      if (!button) return;
      const rail = button.closest(RAIL);
      if (!rail) return;

      event.preventDefault();
      event.stopPropagation();

      const { list } = parts(rail);
      if (!list) return;
      const direction = button.name === 'next' ? 1 : -1;
      list.scrollBy({ top: direction * stepFor(list), behavior: 'smooth' });
    },
    true
  );

  const scan = () => document.querySelectorAll(RAIL).forEach(bind);

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  // The gallery is replaced wholesale when a variant changes.
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('resize', () => document.querySelectorAll(RAIL).forEach((rail) => rail.update?.()));
})();
